import { Controller } from '@hotwired/stimulus';

// #tip パネルに付き、フォーム項目にフォーカスすると /tips から説明を取得して表示する。
// 旧 legacy/tip.js の document 委譲ハンドラを Stimulus 化したもの。#tip は
// shared/_notice で全ページに描画されるため、ハンドラは document へ委譲する。
export default class extends Controller {
  connect() {
    this.onFocus = this.handleFocus.bind(this);
    this.onShow = this.handleShow.bind(this);
    this.onCancel = this.handleCancel.bind(this);
    this.onUpdateSubmit = this.handleUpdateSubmit.bind(this);

    document.addEventListener('focusin', this.onFocus);
    document.addEventListener('click', this.onShow);
    document.addEventListener('click', this.onCancel);
    document.addEventListener('submit', this.onUpdateSubmit);
  }

  disconnect() {
    document.removeEventListener('focusin', this.onFocus);
    document.removeEventListener('click', this.onShow);
    document.removeEventListener('click', this.onCancel);
    document.removeEventListener('submit', this.onUpdateSubmit);
  }

  handleFocus(event) {
    const target = event.target;
    const matches =
      (target.closest('.form-w-tip') &&
        (target.matches('.form-control') || target.matches('label.radio-inline'))) ||
      (target.closest('.formBox') &&
        (target.matches('input') || target.matches('select')));
    if (matches) this.showTip(target);
  }

  async showTip(target) {
    if (target.id === 'tip_text' || target.type === 'submit') return;

    const name = target.getAttribute('name');
    const nameInput = document.querySelector('#updateTip input[name=name]');
    if (nameInput) nameInput.value = name || '';

    try {
      const res = await fetch(`/tips?name=${encodeURIComponent(name || '')}`, {
        headers: { Accept: 'text/html' },
        credentials: 'same-origin',
      });
      const data = await res.text();
      this.element.innerHTML = data;
      if (data === '' && !this.element.classList.contains('admin')) {
        this.element.style.display = 'none';
      } else {
        this.element.style.display = '';
      }
    } catch {
      return;
    }

    this.position(target);
  }

  position(target) {
    const rect = target.getBoundingClientRect();
    const scrollTop = window.pageYOffset;
    const wrap = target.closest('.formBox');
    if (!wrap) {
      const form = target.closest('form');
      if (!form) return;
      const formRect = form.getBoundingClientRect();
      this.element.style.top = `${rect.top + scrollTop}px`;
      this.element.style.left = `${formRect.left + form.offsetWidth}px`;
    } else {
      const wrapRect = wrap.getBoundingClientRect();
      this.element.style.top = `${rect.top - wrapRect.top}px`;
    }
  }

  handleShow(event) {
    const link = event.target.closest('.showLink');
    if (!link) return;
    event.preventDefault();
    const el = document.getElementById(link.dataset.target);
    if (el) el.style.display = 'block';
  }

  handleCancel(event) {
    const link = event.target.closest('.cancelLink');
    if (!link) return;
    event.preventDefault();
    const el = document.getElementById(link.dataset.target);
    if (el) el.style.display = 'none';
  }

  async handleUpdateSubmit(event) {
    const form = event.target;
    if (!form.matches('#updateTip')) return;

    // ツールチップ (#tip パネル) 内でのインライン編集のときだけ AJAX で
    // パネル内容を差し替える。#tip が無いページ (layout false の /tips 単体)
    // ではフォームを素通しし、通常の全画面送信で show を再描画させる。
    const panel = document.getElementById('tip');
    if (!panel) return;

    event.preventDefault();
    try {
      const res = await fetch(form.action, {
        method: 'POST',
        body: new FormData(form),
        credentials: 'same-origin',
        headers: { Accept: 'text/html' },
      });
      panel.innerHTML = await res.text();
    } catch {
      // noop
    }
  }
}
